import React, { useEffect } from "react";
import LogoImage from "../../atoms/Utlis/LogoImage"; // Your logo component or image
import { useParams } from "react-router-dom";
import { completePaymentAPI } from "../../../Redux/ApiCalls/Dashboard/CustomerTransationApi";
import { showErrorToast } from "../../atoms/Utlis/Toast";
import { trackClarityEvent } from "../../../analytics/ClarityAnalytics";
import { CLARITY_EVENTS } from "../../../analytics/EventTypes";

const PaymentCompletePage: React.FC = () => {
  const { token } = useParams();
  useEffect(() => {
    console.log("called");
    if (token) {
      completePaymentAPI(token)
        .then((data) => {
          if (data && data.status) {
            trackClarityEvent(CLARITY_EVENTS.CUSTOMER_PAYMENT_COMPLETED, {
              token: token,
              amount: data.data?.amount,
              customer_name: data.data?.customer_name,
            })
          }
        })
        .catch(() => {
          showErrorToast("Payment failed. Pleased contact studio owner.");
        });
    }
  }, []);
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
      {/* Logo */}
      <div className="mb-6">
        <LogoImage />
      </div>
      {/* Success Icon */}
      <div className="bg-green-100 rounded-full p-6 mb-4">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-16 w-16 text-green-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>
      {/* Message */}
      <h1 className="text-2xl font-bold mb-2 text-gray-800">
        Payment Completed!
      </h1>
      <p className="text-gray-600 text-center max-w-sm">
        Your payment has been successfully processed. Thank you for your
        purchase!
      </p>
      {/* Optional Button */}
    </div>
  );
};

export default PaymentCompletePage;
